import { DEFAULT_SPRITE_COLORS, type AvatarLayerSelection, type SpriteColors } from '../types/user';

const isHexColor = (value: unknown): value is string =>
  typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value.trim());

export const normalizeSpriteColors = (value: unknown): SpriteColors | undefined => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  const candidate = value as Record<string, unknown>;
  if (!isHexColor(candidate.hair) || !isHexColor(candidate.clothing)) {
    return undefined;
  }

  return {
    hair: candidate.hair.trim(),
    clothing: candidate.clothing.trim(),
  };
};

export const isDefaultSpriteColors = (value: SpriteColors): boolean =>
  value.hair.toLowerCase() === DEFAULT_SPRITE_COLORS.hair.toLowerCase() &&
  value.clothing.toLowerCase() === DEFAULT_SPRITE_COLORS.clothing.toLowerCase();

export const normalizeInlineSpriteColors = (
  value: unknown,
  options: {
    avatarLayers?: AvatarLayerSelection;
    spriteId?: string;
  } = {},
): SpriteColors | undefined => {
  const colors = normalizeSpriteColors(value);
  if (!colors) {
    return undefined;
  }

  if (!options.avatarLayers && options.spriteId?.trim() && isDefaultSpriteColors(colors)) {
    return undefined;
  }

  return colors;
};
